import { render, staticRenderFns } from "./FamilyListAccordioin.vue?vue&type=template&id=3946d45a&lang=pug"
import script from "./FamilyListAccordioin.vue?vue&type=script&lang=ts"
export * from "./FamilyListAccordioin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports